import { OfroFlags } from '~/models/OfroFlags';
import { ofroFlagsStorage } from '~/utils/storage/ubieAppStorage';

export function getOfroFlags(): OfroFlags {
  return ofroFlagsStorage.get() || {};
}
